import { EntityClass } from './class-names.js';

export enum AbbreviationReasonsForAbsence {
  KR = EntityClass.KRANKHEIT,
  UR = EntityClass.URLAUB,
  UR_D = EntityClass.DIENSTLICHE_BEURLAUBUNG,
  KF = EntityClass.KLASSENFAHRT,
  EX = EntityClass.EXKURSION,
  FB = EntityClass.FORTBILDUNG,
  DAAO = EntityClass.DIENST_AM_ANDEREN_ORT,
  LP = EntityClass.LEHRPROBE,
  INT = EntityClass.INTERNER_EINSATZ,
  SP = EntityClass.SOZIALPRAKTIKUM,
  FS = EntityClass.FREIE_STUDIEN,
  ABI = EntityClass.ABITURPRUFUNGEN,
}

export enum PartOfDayEnum {
  VORMITTAG = 'VORMITTAG',
  NACHMITTAG = 'NACHMITTAG',
}
